import { render, staticRenderFns } from "./videoEdit.vue?vue&type=template&id=07c8ccce&scoped=true&"
import script from "./videoEdit.vue?vue&type=script&lang=js&"
export * from "./videoEdit.vue?vue&type=script&lang=js&"
import style0 from "./videoEdit.vue?vue&type=style&index=0&id=07c8ccce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c8ccce",
  null
  
)

export default component.exports